import {
  CCPA_Img,
  GDPR_Img,
  HIPPA_Img,
  ISO_2,
  ISO_Img,
  One_Stop_Bg,
} from "../../assets";
import { useModal } from "../../utils/demoProvider";
import { useRef } from "react";
import gsap from "gsap";
import { useGSAP } from "@gsap/react";
import {
  MOTION_OK,
  revealTrigger,
  maskedLineReveal,
  riseFrom,
} from "../../utils/animations";

export default function OneStop() {
  const { openModal } = useModal();
  const sectionRef = useRef(null);

  useGSAP(
    () => {
      const mm = gsap.matchMedia();
      mm.add(MOTION_OK, () => {
        maskedLineReveal(sectionRef.current.querySelector(".onestop-heading"), {
          scrollTrigger: revealTrigger(".onestop-heading"),
        });
        riseFrom(".onestop-copy", {
          delay: 0.2,
          scrollTrigger: revealTrigger(".onestop-copy", "top 85%"),
        });
        riseFrom(".onestop-cta", {
          delay: 0.35,
          scrollTrigger: revealTrigger(".onestop-cta", "top 90%"),
        });
        riseFrom(".trust-card", {
          y: 48,
          duration: 1,
          scrollTrigger: revealTrigger(".trust-card", "top 80%"),
        });
        gsap.from(".trust-badges img", {
          y: 32,
          autoAlpha: 0,
          scale: 0.9,
          duration: 0.7,
          ease: "back.out(1.4)",
          stagger: 0.08,
          scrollTrigger: revealTrigger(".trust-badges", "top 85%"),
        });
      });
      return () => mm.revert();
    },
    { scope: sectionRef }
  );

  return (
    <section
      ref={sectionRef}
      className="py-[96px] lg:pt-[200px] lg:pb-[96px]"
      style={{
        backgroundImage: `url("${One_Stop_Bg}")`,
        backgroundPosition: "center",
        backgroundSize: "cover",
      }}
    >
      <div className="container space-y-16">
        <div className="flex flex-col items-center gap-8">
          <div className="max-w-[890px] space-y-4">
            <h1
              className="onestop-heading text-[32px] md:text-[54px] font-extrabold text-white leading-[1.2] text-center"
              dangerouslySetInnerHTML={{
                __html: "[AI] is your one-stop partner for data insights",
              }}
            />
            <p className="onestop-copy text-white text-sm md:text-base text-center">
              Optimise your data strategy with [AI], your all-in-one assistant
              for impactful insights. Unlock success with our extensive turnkey
              applications tailored to your business, market segment or industry
              sector
            </p>
          </div>

          <button
            onClick={openModal}
            className="onestop-cta py-3 w-[170px] font-semibold text-center btn-sweep btn-sweep-blue text-white rounded-[100px] gap-2"
          >
            Request a Demo
          </button>
        </div>

        <div className="trust-card bg-[#FFFFFF0D] flex flex-col xl:flex-row gap-8 p-6 md:p-8 rounded-xl">
          <div className="flex-1 space-y-4">
            <h1 className="text-white text-[32px] xl:text-[40px] text-center xl:text-left font-extrabold xl:max-w-[510px]">
              Built on Trust <br />
            </h1>

            <h3 className="text-white text-xl lg:text-2xl !leading-[24px] text-center xl:text-left font-extrabold w-full xl:max-w-[510px]">
              Certified, compliant, and secure by design
            </h3>
            
            <p className="text-sm md:text-base text-center xl:text-left text-[#C0C0C0]">
              Your data is always handled with the highest standards of privacy
              and protection.
              <span className="text-white font-bold"> ISO 27001</span>,{" "}
              <span className="text-white font-bold">GDPR</span>,{" "}
              <span className="text-white font-bold">HIPAA</span>, and{" "}
              <span className="text-white font-bold">CCPA</span> compliance
              ensure enterprises can innovate confidently while maintaining full
              governance control. compromise
            </p>
          </div>
          <div className="trust-badges flex-1 flex flex-wrap md:items-center justify-center xl:justify-end gap-8 md:gap-12 rounded-xl">
            <img
              src={ISO_Img}
              alt="compliant logo illustartion"
              className="w-[65px] md:w-[75px]"
            />

            <img
              src={ISO_2}
              alt="compliant logo illustartion"
              className="w-[65px] md:w-[75px]"
            />

            <img
              src={GDPR_Img}
              alt="compliant logo illustartion"
              className="w-[65px] md:w-[75px]"
            />
            <img
              src={HIPPA_Img}
              alt="compliant logo illustartion"
              className="w-[65px] md:w-[75px]"
            />
            <img
              src={CCPA_Img}
              alt="compliant logo illustartion"
              className="w-[65px] md:w-[75px]"
            />
          </div>
        </div>
      </div>
    </section>
  );
}
